export var RANGE_PRICE_DISPLAY_TYPE = 'range';
export var FIRST_PRICE_DISPLAY_TYPE = 'first';